export default "__VITE_ASSET__B20h_$JN__"